module.exports = __webpack_public_path__ + "img/IMG_5883.f390b9b4.jpg";